export const Percent = ({size = 21, className = ''}) => {
  return (
    <i style={{width: size, height: size}} className={`flex justify-center items-center ${className}`}>
      <svg viewBox="0 0 39 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.7 2.29999L4.25 32.75" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M29.7954 34.9241C33.601 34.9241 36.6861 31.8391 36.6861 28.0335C36.6861 24.2279 33.601 21.1429 29.7954 21.1429C25.9898 21.1429 22.9048 24.2279 22.9048 28.0335C22.9048 31.8391 25.9898 34.9241 29.7954 34.9241Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.6526 15.5432C12.4582 15.5432 15.5432 12.4581 15.5432 8.65253C15.5432 4.84694 12.4582 1.7619 8.6526 1.7619C4.847 1.7619 1.76196 4.84694 1.76196 8.65253C1.76196 12.4581 4.847 15.5432 8.6526 15.5432Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </i>
  )
};
